import type { AnalyticsLocationSnapshot } from '../../contexts/analytics-utils';

export function shouldConsumeDownloadedImage(
  image: Blob | undefined,
  lastDownloadedImage: Blob | undefined,
): image is Blob {
  return image !== undefined && image !== lastDownloadedImage;
}

export function resolveDownloadTrackingLocation(
  pendingLocationSnapshot: AnalyticsLocationSnapshot | null,
  currentLocationSnapshot: AnalyticsLocationSnapshot,
): AnalyticsLocationSnapshot {
  return pendingLocationSnapshot ?? currentLocationSnapshot;
}
